var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BButton',{attrs:{"variant":"primary","size":_vm.compact ? 'sm' : null,"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.$emit('complete-step', _vm.step.id)}}},[_vm._v(" "+_vm._s(_vm.resolvedLabel)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }